import { useTranslation } from 'react-i18next';
import { Scissors, Trash2, X, Copy } from 'lucide-react';
import { useEditorStore } from '../../store/editorStore';
import { usePlayheadStore } from '../../store/playheadStore';

export function MobileClipActions() {
  const { t } = useTranslation();
  const selectedClipId = useEditorStore((s) => s.timeline.selectedClipId);
  const splitClip = useEditorStore((s) => s.splitClip);
  const removeClip = useEditorStore((s) => s.removeClip);
  const selectClip = useEditorStore((s) => s.selectClip);

  if (!selectedClipId) return null;

  const handleSplit = () => {
    const timeMs = usePlayheadStore.getState().currentTimeMs;
    splitClip(selectedClipId, timeMs);
  };

  const handleDelete = () => {
    removeClip(selectedClipId);
    selectClip(null);
  };

  const handleDeselect = () => {
    selectClip(null);
  };

  const btnClass =
    'flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors text-[var(--user-page-text)]';

  return (
    <div className="flex items-center justify-center gap-1 px-2 py-1 shrink-0 bg-[#1A1A1E] border-y border-[var(--user-page-accent)]/30">
      <button onClick={handleSplit} className={btnClass}>
        <Scissors size={18} />
        <span className="text-[9px]">{t('editor.split', 'Split')}</span>
      </button>
      <button onClick={handleDelete} className={btnClass}>
        <Trash2 size={18} className="text-red-400" />
        <span className="text-[9px] text-red-400">{t('editor.delete', 'Delete')}</span>
      </button>
      <div className="w-px h-6 bg-[#48484A] mx-1" />
      <button onClick={handleDeselect} className={btnClass}>
        <X size={18} className="opacity-60" />
        <span className="text-[9px] opacity-60">{t('editor.mobile.deselect', 'Deselect')}</span>
      </button>
    </div>
  );
}
